
import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";
import VideoRequest from "./VideoRequest";
import {
    Image,
    Select,
    TimePicker,
    Upload,
} from "antd";

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });


export const CreateVideo = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [fileList, setFileList] = useState([])
    const navigate = useNavigate()
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [videoList, setVideoList] = useState([]);
 const [submited, setSubmit] = useState(false);

 const update=()=>{
    setSubmit(true);

  }

    const onFinish = (values) => {
       
        if(submited){
        setLoading(true);
            const allFormData = { ...values };
            console.log('Submitting data to API:', allFormData)
            VideoRequest.createVideo(allFormData)
                .then((res) => {
                    console.log('API Response:', res);
                    if (res.status === 201) {
                        notification.success({
                            message: "Video added successfully",
                        });
                        navigate(-1);
                    } else {
                        notification.error({
                            message: "Something went wrong",
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    setLoading(false);
                    notification.error({
                        message: "Failed to add category",
                    });
                    console.error("API Error:", e);
                });
        }
    };

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const handleSubmit = () => {
        form.submit();
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleImageChange = ({ fileList: newFileList }) =>{
        console.log("img hjjk",newFileList);
        setFileList(newFileList);
    }

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
        >
            <GrUpload />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const imageUpload = (file, name) => {
        // setLoading(true);
        console.log("terturgui=",file);
        const modifiedFile = new File([file], name, { type: file.type });
        let formData = new FormData();
        formData.append("file", modifiedFile);
        formData.append("fileName", name);
    
        VideoRequest.uploadImage(formData).then((res) => {
                form.setFieldsValue({
                    thumbnail: res?.data?.uploadDirectory,
                });
                if (res) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch((e) => {
                setLoading(false);
                notification["error"]({
                    message: "File upload Failed",
                });
            });
    };

//     const props = {
//         name: "file",
//         multiple: false,
//         beforeUpload: (file) => {
// console.log("===",file);
//             imageUpload(file, file.name);
//             return false;
//         },
//         onRemove() {
//             setFileList([]);
//         },
//     };

  const props = {
    name: "file",
    multiple: false,
    accept : "image/*",
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if(!isImage){
        notification.error({
          message : "Invalid file type",
          description : "Only image files are allowed (jpg, png, jpeg, webp)",
        });
        return Upload.LIST_IGNORE; 
      }
      imageUpload(file, file.name);
      return false;
    },
    onRemove() {
      setFileList([]);
    },
  };

    return (
        <div>
            <section>
                <div className="Create-Category">
                    <Form.Item className=" submit-btn">
                        <Space>
                            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                                <ArrowLeftOutlined />
                            </Button>
                        </Space>
                    </Form.Item>
                    <h3>Add Video</h3>


                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={null}
                        onFinish={onFinish}
                    >
                        {/* First Row */}
                        <div className="subscription">
                            <Form.Item
                                name="title"
                                label="Title"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please enter the User name!" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "Title can only contain letters and spaces.",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter Title" />
                            </Form.Item>

                            <Form.Item
                                name="description"
                                label="Description"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please enter description" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "Description can only contain letters and spaces.",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter Description" />
                            </Form.Item>

                        </div>
                        <div className="subscription">
                            {/* Status Field */}
                            <Form.Item
                                name="status"
                                label="Status"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please select a status!" }]}
                            >
                                <Select placeholder="Select Status">
                                    <Select.Option value="1">Active</Select.Option>
                                    <Select.Option value="0">Inactive</Select.Option>
                                </Select>
                            </Form.Item>

                            {/* YouTube Video Link Field */}
                            <Form.Item
                                name="videoUrl"
                                label="Video Url"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please video link!" },
                                    
                                {
                                    type: 'url',
                                    message: "Please enter a valid URL!",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter YouTube Video Link" />
                            </Form.Item>

                        </div>

                        <div className="upload-Img" style={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Form.Item
                                label="Order By"
                                name="orderby"
                                className="subscription-plan"
                                rules={[
                                    { required: true, message: "Please select order" },
                                ]}
                            >
                                <Select
                                    placeholder="Select order"
                                    // style={{
                                    //     marginTop: "0.5rem",

                                    //     width: "99%",
                                    // }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: "1",
                                            label: "1",
                                        },
                                        {
                                            value: "2",
                                            label: "2",
                                        },
                                        {
                                            value: "3",
                                            label: "3",
                                        },
                                        {
                                            value: "4",
                                            label: "4",
                                        },
                                        {
                                            value: "5",
                                            label: "5",
                                        },

                                    ]}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Add Thumbnail"
                                name="thumbnail"
                                className="subscription-plan"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please upload the Thumbnail",
                                    },
                                ]}
                            >
                                <Upload
                                    {...props} maxCount={1}
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleImageChange}
                                >
                                    {fileList.length >= 8 ? null : uploadButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{
                                            display: "none",
                                        }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) =>
                                                !visible && setPreviewImage(""),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                            </Form.Item>

                            {/* <Form.Item
                                label="Add Videos"
                                name="salonVideos"
                                className="subscription-plan"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please upload the salon videos",
                                    },
                                ]}
                            >
                                <Upload
                                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                    listType="picture-card"
                                    fileList={videoList}
                                    className="salon-video-upload-input"
                                    onPreview={handleVideoPreview}
                                    onChange={handleVideoListChange}
                                    accept="video/*" // Restrict file type to videos
                                >
                                    {videoList.length >= 8 ? null : uploadButton}
                                </Upload>

                                <Modal
                                    visible={isVideoPreviewOpen}
                                    title={previewVideoTitle}
                                    footer={null}
                                    onCancel={() => setIsVideoPreviewOpen(false)}
                                >
                                    <video controls style={{ width: "100%" }}>
                                        <source src={previewVideoUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </Modal>
                            </Form.Item> */}
                        </div>



                        <div className="bottom-button">
                            <div style={{ padding: "10px" }}>
                                <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                                    Save & Proceed
                                    <span>
                                        <AiOutlineRight />
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </section>
        </div>
    )
}
